import * as React from 'react';

import { cn } from '@/utils/cn';

export const formFieldClass =
  'w-full rounded-lg border border-gray-200 bg-white px-4 py-3 text-[15px] font-medium text-[#0f172a] outline-none transition-colors focus:border-primary disabled:cursor-not-allowed disabled:opacity-50';

export const formLabelClass = 'mb-2 block text-[13px] uppercase text-[#475569]';

export const formCardClass = 'overflow-hidden  border border-slate-200 bg-gray-50';

export const formCardBodyClass = 'space-y-5 px-5 py-5';

export const formFooterClass = 'flex justify-end gap-2  px-5 py-5';

export const formCancelButtonClass =
  'rounded-lg border border-gray-200 px-5 py-[16px] text-[16px] font-bold text-[#475569] transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50';

export const formSubmitButtonClass =
  'flex min-w-[180px] items-center justify-center gap-2 rounded-lg bg-primary px-5 py-[16px] text-[16px] font-bold text-white transition-colors hover:bg-primary/80 disabled:cursor-not-allowed disabled:opacity-50';

export const FormLabel = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label ref={ref} className={cn(formLabelClass, className)} {...props} />
));
FormLabel.displayName = 'FormLabel';

export const FormInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <input ref={ref} className={cn(formFieldClass, className)} {...props} />
));
FormInput.displayName = 'FormInput';

export const FormSelect = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select ref={ref} className={cn(formFieldClass, className)} {...props} />
));
FormSelect.displayName = 'FormSelect';

export const FormTextarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea ref={ref} className={cn(formFieldClass, className)} {...props} />
));
FormTextarea.displayName = 'FormTextarea';

